















































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import BindAttrs from '@/utils/binds-attrs';

import '@/compiled-icons/polygon-segment';
import '@/compiled-icons/circle-segment';
import '@/compiled-icons/square-segment';
import AmetrasNumberFieldTemplate from '@/fields/text/AmetrasNumberFieldTemplate.vue';
import AmetrasTextFieldTemplate from '@/fields/text/AmetrasTextFieldTemplate.vue';
import {
  AMETRAS_MACHINE_WORKING_AREA_BOUNDARY_UTILS_INSTANCE
} from '@/utils/ametras-machine-working-area-boundary.utils';
import {ResizeSensor} from 'css-element-queries';

/**
 * General Component for Fields of type CHECKBOX
 *
 * https://confluence.ametras.com/x/L4RQAw
 */
@Component({
  mixins: [BindAttrs],
  components: {AmetrasNumberFieldTemplate, AmetrasTextFieldTemplate}
})
export default class AmetrasMachineWorkingAreaBoundaryTemplate extends Vue {
  @Prop() textAlign!: 'LEFT' | 'RIGHT' | 'CENTER' | 'JUSTIFIED';
  @Prop() value!: DisguiseDto.MachineWorkingAreaBoundaryValueDto | null | undefined;
  @Prop() label!: string;
  @Prop() readonly!: boolean;

  $refs!: {
    canvas: HTMLCanvasElement
    canvasWrapper: HTMLDivElement
  };

  maxDistance = 0;
  leftSidePolygonSegments: DisguiseDto.MachineWorkingAreaBoundaryPolygonSegmentDto[] = [];
  rightSidePolygonSegments: DisguiseDto.MachineWorkingAreaBoundaryPolygonSegmentDto[] = [];
  circleSegments: DisguiseDto.MachineWorkingAreaBoundaryCircleSegmentDto[] = [];
  squareSegments: DisguiseDto.MachineWorkingAreaBoundarySquareSegmentDto[] = [];

  private resizeSensor: ResizeSensor | undefined;

  created() {
    const defaultConfig = AMETRAS_MACHINE_WORKING_AREA_BOUNDARY_UTILS_INSTANCE.getDefaultConfig();
    const polygonSplitIdx = Math.ceil(((defaultConfig || {}).polygonSegments || []).length / 2);
    this.leftSidePolygonSegments = ((defaultConfig || {}).polygonSegments || []).slice(0, polygonSplitIdx);
    this.rightSidePolygonSegments = ((defaultConfig || {}).polygonSegments || []).slice(polygonSplitIdx, ((defaultConfig || {}).polygonSegments || []).length);
    this.circleSegments = (defaultConfig || {}).circleSegments || [];
    this.squareSegments = (defaultConfig || {}).squareSegments || [];
    this.maxDistance = (defaultConfig || {}).maxDistance || 0;
  }

  @Watch('value') valueChanged(newValue: DisguiseDto.MachineWorkingAreaBoundaryValueDto | null | undefined) {
    if (newValue !== undefined && newValue !== null) {
      if (newValue.polygonSegments) {
        const polygonSplitIdx = Math.ceil(newValue.polygonSegments.length / 2);
        this.leftSidePolygonSegments = newValue.polygonSegments.slice(0, polygonSplitIdx);
        this.rightSidePolygonSegments = newValue.polygonSegments.slice(polygonSplitIdx, newValue.polygonSegments.length);
      }
      if (newValue.circleSegments) {
        this.circleSegments = newValue.circleSegments;
      }
      if (newValue.squareSegments) {
        this.squareSegments = newValue.squareSegments;
      }
      if (newValue.maxDistance !== undefined && newValue.maxDistance > 0) {
        this.maxDistance = newValue.maxDistance;
      }
    }
  }

  mounted() {
    this.resizeSensor = new ResizeSensor(this.$refs.canvasWrapper, () => {
      this.redraw();
    });
  }

  redraw() {
    const size = this.$refs.canvasWrapper.offsetWidth || 300;
    this.$refs.canvas.width = size;
    this.$refs.canvas.height = size;
    const ctx = this.$refs.canvas.getContext('2d');
    if (ctx != null) {
      ctx.save();
      ctx.clearRect(0, 0, size, size);

      AMETRAS_MACHINE_WORKING_AREA_BOUNDARY_UTILS_INSTANCE.drawCoords(
          ctx,
          size,
          this.maxDistance
      );
      AMETRAS_MACHINE_WORKING_AREA_BOUNDARY_UTILS_INSTANCE.drawPolygons(
          ctx,
          new Array<DisguiseDto.MachineWorkingAreaBoundaryPolygonSegmentDto>().concat(this.leftSidePolygonSegments, this.rightSidePolygonSegments),
          size,
          this.maxDistance
      );
      AMETRAS_MACHINE_WORKING_AREA_BOUNDARY_UTILS_INSTANCE.drawCircleSegments(
          ctx,
          this.circleSegments,
          size,
          this.maxDistance
      );
      AMETRAS_MACHINE_WORKING_AREA_BOUNDARY_UTILS_INSTANCE.drawSquare(
          ctx,
          this.squareSegments,
          size,
          this.maxDistance
      );
    }
    const newValue: DisguiseDto.MachineWorkingAreaBoundaryValueDto = {
      maxDistance: this.maxDistance,
      polygonSegments: new Array<DisguiseDto.MachineWorkingAreaBoundaryPolygonSegmentDto>().concat(this.leftSidePolygonSegments, this.rightSidePolygonSegments),
      circleSegments: this.circleSegments,
      squareSegments: this.squareSegments
    };
    this.$emit('input', newValue);
  }
}
